export default () => {

  $('.file-uploader .input-file').on('change', (e) => {
    $(e.target).parent().find('.file-upload-filename').text(e.target.files[0].name);
  });

};
